import React from 'react'
import type {ReactElement} from 'react'

export default function WebInternalPlan(): ReactElement {
  return <div>Hello world</div>
}
